//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

// TODO учитывать listelementtype

export default {
  name: 'CardPropertyList',
  components: {
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    let value = this.object[this.tabProp.key]
    if (this.tabProp.componentProps && this.tabProp.componentProps.arrayModel && !this.tabProp.ismultiselect) {
      if (this.object[this.tabProp.key] && this.object[this.tabProp.key].length) {
        value = this.object[this.tabProp.key][0]
      }
    }
    return {
      value: value,
      options: []
    }
  },
  computed: {
    inputValue: function () {
      return this.object[this.tabProp.key]
    },
    componentProps: function () {
      return (this.tabProp && this.tabProp.componentProps) || {}
    },
    copyAvailable: function () {
      const config = this.tabProp || {}
      return config.componentProps && config.componentProps.copy
    },
    itemsList: function () {
      return this.inputValue || []
    },
    itemsText: function () {
      if (this.itemsList && this.itemsList.length) {
        return this.itemsList.join(', ')
      }
      return null
    }
  },
  watch: {
    value: {
      handler: function () {
        if (this.componentProps.arrayModel && !this.tabProp.ismultiselect) {
          if (this.value) {
            this.object[this.tabProp.key] = [this.value]
          } else {
            this.object[this.tabProp.key] = []
          }
        } else {
          this.object[this.tabProp.key] = this.value
        }
      },
      immediate: true
    },
    inputValue: {
      handler: function () {
        // if (this.object[this.tabProp.key] === null || this.object[this.tabProp.key] && this.object[this.tabProp.key].length === 0) {
        //   this.value = this.object[this.tabProp.key]
        // }
      },
      immediate: true
    }
  },
  methods: {
    onInput: function (value) {
      if (!value || value.length == 0) {
        this.object[this.tabProp.key] = []
      } else {
        // TODO другие изменения запрещены
      }
    },
    onClick: function (event) {
      if (this.ignoreNextNativeClickEvent) {
        this.ignoreNextNativeClickEvent = false
        return
      }
      this.ignoreNextNativeClickEvent = true

      this.onEdit(event)
    },
    onEdit: function (event) {
      if (!this.readonly) {
        // TODO
        console.log('Открыть редактор')
      }
    },
    onCopy: function (e) {
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([this.itemsText], { type: 'text/plain' }) })]
      navigator.clipboard.write(data)
    }
  }
}
